"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSelectionRowEvent = exports.isSelectionColumnEvent = exports.createSelectionColumn = exports.SPACE_BAR = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LayoutStyles_1 = require("../style/LayoutStyles");
const StyleFunctions_1 = require("../style/StyleFunctions");
const CellStyles_1 = require("./cellFormatters/CellStyles");
const TypedDataGridInterfaces_1 = require("./TypedDataGridInterfaces");
exports.SPACE_BAR = ' ';
const selectionContainerClass = (0, StyleFunctions_1.cssClass)('selectionContainer', LayoutStyles_1.elideTextStyle, CellStyles_1.cellPaddingStyle, {
    height: '100%',
});
function createSelectionColumn() {
    return {
        name: TypedDataGridInterfaces_1.SelectionColumnKey,
        dataKey: TypedDataGridInterfaces_1.SelectionColumnKey,
        headerText: '',
        // eslint-disable-next-line react/display-name
        cellFormatter: (props) => (react_1.default.createElement("div", { className: selectionContainerClass },
            react_1.default.createElement(widgets_1.CheckBoxWidget, { checked: props.isSelected, testId: `checkbox-cell-${props.row.key}` }))),
        resizable: false,
        sortable: false,
    };
}
exports.createSelectionColumn = createSelectionColumn;
function isSelectionColumnEvent(event) {
    const isSelectionColumn = event.cell.colKey === TypedDataGridInterfaces_1.SelectionColumnKey;
    const fromMouseClick = event.type === 'mousedown';
    const fromSpaceBarPress = event.type === 'keydown' && event.key === exports.SPACE_BAR;
    return isSelectionColumn && (fromMouseClick || fromSpaceBarPress);
}
exports.isSelectionColumnEvent = isSelectionColumnEvent;
function isSelectionRowEvent(event) {
    const isSelection = !!event.cell.rowKey;
    return isSelection
        && (event.type === 'mousedown' || event.type === 'touchstart' || (event.type === 'keydown' && event.key === ' '));
}
exports.isSelectionRowEvent = isSelectionRowEvent;
//# sourceMappingURL=SelectionColumn.js.map